import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerAddMoneyApiCallSuccess } from 'redux/actions';
import { TRIGGER_ADD_MONEY_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { nativeHandler } from 'utils';

function* triggerAddMoneyApiCall(actions) {
	const { data, callback } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.PREPAID_ADD_MONEY,
		data,
		method: 'POST',
		options: {
			dontRemoveLoader: true,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			// callback && callback(apiData)
			yield put(triggerAddMoneyApiCallSuccess(apiData));
			localStorage.setItem('orderId', apiData?.orderId);
			nativeHandler.openDeepLinkWithCallback(apiData?.paymentDeepLink, () => {
				nativeHandler.removeLoader();
				callback(apiData?.orderId);
			});
		}
	} else {
		nativeHandler.removeLoader();
	}
}

export default function* triggerAddMoneyApiCallSaga() {
	yield takeEvery(TRIGGER_ADD_MONEY_API, triggerAddMoneyApiCall);
}
